import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-collapsible',
  imports: [],
  templateUrl: './collapsible.component.html',
  styleUrl: './collapsible.component.scss'
})
export class CollapsibleComponent {
  @Input() title = '';
  @Input() isExpanded = true;

  toggle(): void {
    this.isExpanded = !this.isExpanded;
  }
}
